var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "scan-result"
  }, [_c('v-btn', {
    attrs: {
      "color": "accent",
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.textModal = true;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-cog")])], 1), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "width": "600"
    },
    model: {
      value: _vm.textModal,
      callback: function callback($$v) {
        _vm.textModal = $$v;
      },
      expression: "textModal"
    }
  }, [_c('v-card', {
    staticClass: "dialog-form"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('scanresult_scan_response_text_settings')))]), _c('v-card-text', [_c('div', {
    staticClass: "description font-weight-light pa-6"
  }, [_vm._v(_vm._s(_vm.$t('scanresult_edit_text_description')))]), _c('div', {
    staticClass: "px-6"
  }, [_c('span', {
    staticClass: "label font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('scanresult_scan_response_text')) + " ")]), !_vm.isAvailable('editor:scan_result:text') ? _c('info-tooltip', {
    staticClass: "ml-3",
    attrs: {
      "content": _vm.$t('scanresult_upgrade_unlock_feature')
    }
  }) : _vm._e()], 1), !_vm.isAvailable('editor:authentication') ? _c('div', [_c('v-text-field', {
    staticClass: "pa-0 px-6",
    attrs: {
      "disabled": !_vm.isAvailable('editor:scan_result:text') || !_vm.overrideAuthMessage,
      "hide-details": "",
      "placeholder": _vm.$t('scanresult_enter_customized_text')
    },
    model: {
      value: _vm.authMessageOverride.active,
      callback: function callback($$v) {
        _vm.$set(_vm.authMessageOverride, "active", $$v);
      },
      expression: "authMessageOverride.active"
    }
  })], 1) : _vm._e(), _vm.isAvailable('editor:authentication') ? _c('div', [_c('div', {
    staticClass: "px-6"
  }, [_c('v-radio-group', {
    staticClass: "inset ma-0",
    attrs: {
      "disabled": !_vm.isAvailable('editor:scan_result:text'),
      "column": ""
    },
    model: {
      value: _vm.overrideAuthMessage,
      callback: function callback($$v) {
        _vm.overrideAuthMessage = $$v;
      },
      expression: "overrideAuthMessage"
    }
  }, [_c('v-radio', {
    staticClass: "py-2 ma-0",
    attrs: {
      "value": false,
      "label": _vm.$t('scanresult_default_scan_response_text')
    }
  }), _c('v-radio', {
    staticClass: "ma-0",
    attrs: {
      "value": true,
      "label": _vm.$t('scanresult_customized_scan_response_text')
    }
  })], 1)], 1), _c('div', {
    staticClass: "table pl-14"
  }, [_c('div', {
    staticClass: "d-flex flex-row table-header"
  }, [_c('div', {
    staticClass: "item font-weight-bold text-caption"
  }, [_vm._v(_vm._s(_vm.$t('scanresult_default_text')))]), _c('div', {
    staticClass: "item font-weight-bold text-caption"
  }, [_vm._v(_vm._s(_vm.$t('scanresult_customized_text')))])]), _vm.isAvailable('editor:authentication') ? _c('div', {
    staticClass: "d-flex flex-row flex-grow-1 table-row pt-2"
  }, [_c('div', {
    staticClass: "item py-2 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('genuine')))]), _c('div', {
    staticClass: "item flex-grow-1"
  }, [_c('v-textarea', {
    staticClass: "ma-0 pa-0 pr-6",
    attrs: {
      "disabled": !_vm.isAvailable('editor:scan_result:text') || !_vm.overrideAuthMessage,
      "hide-details": "",
      "placeholder": _vm.$t('scanresult_enter_customized_text'),
      "rows": "1",
      "auto-grow": ""
    },
    model: {
      value: _vm.authMessageOverride.genuine,
      callback: function callback($$v) {
        _vm.$set(_vm.authMessageOverride, "genuine", $$v);
      },
      expression: "authMessageOverride.genuine"
    }
  })], 1)]) : _vm._e(), _c('div', {
    staticClass: "d-flex flex-row flex-grow-1 table-row pt-2"
  }, [_c('div', {
    staticClass: "item py-2 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('active_code')))]), _c('div', {
    staticClass: "item flex-grow-1"
  }, [_c('v-textarea', {
    staticClass: "ma-0 pa-0 pr-6",
    attrs: {
      "disabled": !_vm.isAvailable('editor:scan_result:text') || !_vm.overrideAuthMessage,
      "hide-details": "",
      "placeholder": _vm.$t('scanresult_enter_customized_text'),
      "rows": "1",
      "auto-grow": ""
    },
    model: {
      value: _vm.authMessageOverride.active,
      callback: function callback($$v) {
        _vm.$set(_vm.authMessageOverride, "active", $$v);
      },
      expression: "authMessageOverride.active"
    }
  })], 1)]), _vm.isAvailable('editor:authentication') ? _c('div', {
    staticClass: "d-flex flex-row flex-grow-1 table-row pt-2"
  }, [_c('div', {
    staticClass: "item py-2 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('unable_to_verify')))]), _c('div', {
    staticClass: "item flex-grow-1"
  }, [_c('v-textarea', {
    staticClass: "ma-0 pa-0 pr-6",
    attrs: {
      "disabled": !_vm.isAvailable('editor:scan_result:text') || !_vm.overrideAuthMessage,
      "hide-details": "",
      "placeholder": _vm.$t('scanresult_enter_customized_text'),
      "rows": "1",
      "auto-grow": ""
    },
    model: {
      value: _vm.authMessageOverride.fake,
      callback: function callback($$v) {
        _vm.$set(_vm.authMessageOverride, "fake", $$v);
      },
      expression: "authMessageOverride.fake"
    }
  })], 1)]) : _vm._e()])]) : _vm._e(), _c('div', {
    staticClass: "pa-6"
  }, [_c('div', {
    staticClass: "label font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('scanresult_powered_by_scantrust')))]), _c('v-switch', {
    staticClass: "ma-0 pt-4",
    attrs: {
      "disabled": !_vm.isAvailable('editor:scan_result:branding'),
      "hide-details": "",
      "label": "".concat(_vm.$t('scanresult_display_brand_text'), ": ").concat(_vm.enableBranding ? _vm.$t('yes') : _vm.$t('no'))
    },
    model: {
      value: _vm.enableBranding,
      callback: function callback($$v) {
        _vm.enableBranding = $$v;
      },
      expression: "enableBranding"
    }
  })], 1), _c('div', {
    staticClass: "pa-6 pt-3"
  }, [_c('div', {
    staticClass: "label font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('styling')))]), _vm._l(_vm.statuses, function (status) {
    return _c('div', {
      key: "".concat(status.key, "-").concat(_vm.styleBarKey),
      staticClass: "style-status-block mt-3"
    }, [_c('style-bar', {
      attrs: {
        "css-keys": ['fontSize', 'color', 'background', 'textAlign'],
        "default-font-size": 24,
        "styles": _vm.localAuthMessageStyles[status.key]
      },
      on: {
        "update:styles": function updateStyles($event) {
          return _vm.$set(_vm.localAuthMessageStyles, status.key, $event);
        }
      },
      scopedSlots: _vm._u([{
        key: "actions",
        fn: function fn() {
          return [_vm.isAvailable('editor:tabs:tools:css') ? _c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function fn(_ref) {
                var on = _ref.on;
                return [_c('v-icon', _vm._g({
                  staticClass: "mr-2",
                  attrs: {
                    "color": "accent"
                  },
                  on: {
                    "click": function click($event) {
                      return _vm.openCssEditor(status.key);
                    }
                  }
                }, on), [_vm._v("mdi-code-json")])];
              }
            }], null, true)
          }, [_c('span', [_vm._v(_vm._s(_vm.$t('css_editor')))])]) : _vm._e()];
        },
        proxy: true
      }], null, true)
    }), _c('div', {
      staticClass: "style-preview",
      style: _vm.localAuthMessageStyles[status.key],
      domProps: {
        "textContent": _vm._s(_vm.getPreviewText(status.key))
      }
    })], 1);
  })], 2)]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        return _vm.cancelChanges();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function click($event) {
        return _vm.saveChanges();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.cssEditorModal,
      callback: function callback($$v) {
        _vm.cssEditorModal = $$v;
      },
      expression: "cssEditorModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('css_editor')))]), _c('vue-json-editor', {
    staticClass: "fullscreen",
    attrs: {
      "mode": "code",
      "expandedOnStart": true
    },
    model: {
      value: _vm.cssEditorContent,
      callback: function callback($$v) {
        _vm.cssEditorContent = $$v;
      },
      expression: "cssEditorContent"
    }
  }), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.cssEditorModal = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.saveCssEditor();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }